import { QuestionCategory } from "./question-category";

export interface QuestionData {
    id?: number;
    title?: string;
    text?: string;
    questionCategoryId?: number;
    translations?: any;

    category?: QuestionCategory;
}

export class Question {
  public static getNonTranslatableFields(): string[] { return ['id', 'questionCategoryId']; }
  public static getTranslatableFields(): string[] { return ['title', 'text']; }
  public static getFields(): string[] { return ['id', 'title', 'text', 'questionCategoryId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  title?: string;
  text?: string;
  questionCategoryId?: number;
  translations?: any;

  category?: QuestionCategory;


  public static fromAPI(data: QuestionData): Question {
    let translationData: any = {};
    if (data.translations) {
      for (let i = 0; i < data.translations?.length; i++) {
        if (data.translations[i]['questionId'] === data['id']) {
          translationData = data.translations[i];
          i = data.translations?.length;
        }
      }
    }
    if (data.category) {
      data.category = QuestionCategory.fromAPI(data.category);
    }
    return new Question({
      id: data.id,
      title: translationData.title ?? data.title,
      text: translationData.text ?? data.text,
      questionCategoryId: data.questionCategoryId,
      category: data.category,
      translations: data.translations
    });
  }
  public static fromAPIList(data: QuestionData[]): Question[] {
    return data.map((question) => Question.fromAPI(question));

  }

  constructor({id, title, text, questionCategoryId, category, translations}: QuestionData) {
    this.id = id;
    this.title = title;
    this.text = text;
    this.questionCategoryId = questionCategoryId;
    this.category = category;
    this.translations = translations;
  }


  public toJson(): QuestionData {
    return {
      id: this.id,
      title: this.title,
      text: this.text,
      questionCategoryId: this.questionCategoryId
    };
  }
}
